import React, {useState} from "react";
import { LocalAudioTrack } from "twilio-video";
import { fetchSession } from "api/webservice/sessions";
import { Session } from "types";
/* import Room from "./Room"; */
import { SELECTED_AUDIO_INPUT_KEY } from "context/session/VideoProvider/constants";
import { useDevices, useVideoContext } from "hooks/session";
import { AudioButton } from "../Buttons";
import AudioLevelIndicator from "pages/Sessions/SessionCallPreview/AudioLevelIndicator";
import DeviceSelector from "pages/Sessions/SessionCallPreview/DeviceSelector";
import { HStack, Text } from "@chakra-ui/react";
import { Card } from "components";
import { Box, Button, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import AudioSettingsPanel from "./AudioSettingsPanel";
/* import VoiceSelectorPanel from "./VoiceSelectorPanel"; */

interface Props {
  sessionId?: string;
  componentHeight: number;
  toggleGameLiftStreamsInput: any;
}

//note: device selector and audio level indicator are here as placeholders, may remove/update on future commits
const VoiceMorph: React.FC<Props> = ({sessionId, componentHeight, toggleGameLiftStreamsInput}: Props) => {
  const { localTracks, getLocalAudioTrack } = useVideoContext();
/*   const { audioInputDevices } = useDevices(); */
  const track = localTracks.find(
    track => track.kind === "audio"
  ) as LocalAudioTrack;

/*   const replaceTrack = (newDeviceId: string) => {
    window.localStorage.setItem(SELECTED_AUDIO_INPUT_KEY, newDeviceId);
    track.restart({ deviceId: { exact: newDeviceId } });
    getLocalAudioTrack(newDeviceId);
  }; */

  const [isAudioSettingsSelected, setIsAudioSettingsSelected] = useState(true);
  const [displayName, setDisplayName] = useState("Audio Settings");
  const [chevronDirection, setChevronDirection] = useState<any>(BsChevronDown);

  const selectDisplayName = () => {
    if (displayName == "Audio Settings") {
      setDisplayName("Your Voices");
      setIsAudioSettingsSelected(false);
    } else {
      setDisplayName("Audio Settings");
      setIsAudioSettingsSelected(true);
    }
    setChevronDirection(BsChevronDown);
  };

  const selectChevronDirection = () => {
    setChevronDirection(BsChevronUp);
  };

  return (
    <Card height={componentHeight} onClick={() => toggleGameLiftStreamsInput(false)}>
      <Box>
        <Menu>
          {({ isOpen }) => (
            <>
{/*               <MenuButton
                isActive={isOpen}
                as={Button}
                size="xs"
                bgColor="transparent"
                color="white"
                borderColor="transparent"
                _hover={{ bg: "transparent" }}
                _active={{ bg: "transparent" }}
                _focus={{ bg: "transparent" }}
                onClick={selectChevronDirection}
                p="0px"
              > */}
                <HStack>
                  <Text fontSize="20px" fontWeight="600">
                    {displayName}
                  </Text>
                  {/* {chevronDirection} */}
                </HStack>
              {/* </MenuButton> */}
              <MenuList
                bgColor="gray.700"
                color="gray.100"
              >
                <MenuItem
                  onClick={selectDisplayName}
                  _hover={{ bg: "gray.100", color: "gray.700" }}
                  _focus={{ bg: "gray.100", color: "gray.700" }}
                >
                  Audio Settings
                </MenuItem>
{/*                 <MenuItem
                  onClick={selectDisplayName}
                  _hover={{ bg: "gray.100", color: "gray.700" }}
                  _focus={{ bg: "gray.100", color: "gray.700" }}
                >
                  Your Voices
                </MenuItem> */}
              </MenuList>
            </>
          )}
        </Menu>
      </Box>
      {isAudioSettingsSelected && <AudioSettingsPanel/>}
      {/* {!isAudioSettingsSelected && <VoiceSelectorPanel/>} */}
    </Card>
  );
};

export default VoiceMorph;